// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3TV9l","errorLogs":"styles_errorLogs__1mGfS"};